import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Cart = () => {
    const [cartps, setcart] = useState([]);
    const { idk, email } = useSelector((state) => state);
    const [total, setotal] = useState();
    const [shiping, setship] = useState('');
    const getCarta = async () => {
        let resp = await fetch(`https://backend-ecomweb.onrender.com/api/getcart/${idk}`);
        if (resp.ok) {
            let res = await resp.json();
            setcart(res.carts);
        }
        else {
            alert("fail")
        }
    }

    const plcorder = async() =>{
        const data = {usrid: idk, orders: cartps, totalprice: total, orderid: Date.now(), umail: email, shipadd: shiping};
        const resp = await fetch(`https://backend-ecomweb.onrender.com/api/placeorder/${idk}`,
            {
                method: "post",
                body: JSON.stringify(data),
                headers: {'Content-type': 'application/json'}
            }
        )
        if(resp.ok){
            let res = await resp.json();
            if(res.statuscode==1){
                alert("success")
            }else{
                alert("fail to fetch api")
            }
        }
    }

    const clr = async () => {
        let resp = await fetch(`https://backend-ecomweb.onrender.com/api/clearcart/${idk}`,
            {
                method: "put",
                headers: { 'Content-type': 'application/json' },
            }
        );
        if (resp.ok) {
            const res = await resp.json();
            if (res.statuscode == 1) {
                alert("success")
            }
        }
        else {
            alert("failed to fetch api")
        }
    }
    useEffect(() => {
        const sum = Number(cartps.reduce((total, item) => total + Number(item.price), 0));
        setotal(Math.round(sum));
    }, [cartps]);




    useEffect(() => {
        getCarta();
    }, [idk])
    return (
        <>   {
            cartps.length > 0 ?
                <div className="cartbox mt-5">
                    <div className="formt mt-1">

                        <form >
                            <table className="table">
                                <tr>
                                    <td> Image: </td>
                                    <td> Title: </td>
                                    <td> Price </td>
                                </tr>

                                {
                                    cartps.map((data, ind) => (
                                        <>
                                            <tr key={ind}>
                                                <td> <img src={data.thumbnail} width={"300px"} />  </td>
                                                <td> {data.title} </td>
                                                <td> ${Math.round(data.price)} </td>
                                            </tr>
                                        </>
                                    ))
                                }
                                <tr>
                                    <td colSpan={2}> Total: </td>
                                    <td colSpan={2}> ${total} </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <div className="in-btw mt-2">
                        <input type="text" onChange={(e)=>setship(e.target.value)} className="form-control" placeholder="Enter shipping address" />
                    </div>
                    <div className="in-btw mt-3">
                        <button className="btn btn-primary" onClick={plcorder}> Place order </button> &nbsp; &nbsp;
                        <button onClick={clr} className="btn btn-danger"> Clear cart </button>
                    </div>

                </div >

                :
                <h2> clear cart </h2>
        }
        </>
    );

}

export default Cart;